// generated by genversion
export var version = '3.8.19';
//# sourceMappingURL=version.js.map